
// import Feedbacks from '../Feedbacks/index.vue'
import InnerPageTitle from '../Shared/InnerPageTitle/index.vue'
import EventListOfUsList from './List.vue'
export default {
  components: {
    InnerPageTitle,
    EventListOfUsList,
  },
}
